import PropTypes from 'prop-types'
import { useRef } from 'react'
import Slider from 'react-slick'
import './slick/slick.css'
import './slick/slick-theme.css'

const CarouselBig = ({ adjuntos }) => {
  const refSliderBig = useRef()

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px'
  }

  return (
    <div className="carousel-big">
      <Slider {...settings} ref={refSliderBig}>
        {adjuntos.map((adjunto, index) => (
          <div key={index}>
            <p>
              <img src={adjunto} alt={''} />
            </p>
          </div>
        ))}
      </Slider>
    </div>
  )
}

CarouselBig.propTypes = {
  adjuntos: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default CarouselBig
